import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M425.817625,709.983006 L425.817625,943.4103 C425.817625,1236.96134 664.763523,1475.90724 958.314561,1475.90724 C1251.8656,1475.90724 1490.8115,1236.96134 1490.8115,943.4103 L1490.8115,709.983006 L1587.62912,709.983006 L1587.62912,943.4103 C1587.62912,1274.11677 1331.19106,1546.07818 1006.72823,1570.88121 L1006.723,1823.182 L1248.76744,1823.18238 L1248.76744,1920 L667.861687,1920 L667.861687,1823.18238 L909.905,1823.182 L909.900895,1570.88121 C585.438064,1546.07818 329,1274.11677 329,943.4103 L329,709.983006 L425.817625,709.983006 Z M958.314561,0 C1198.51909,0 1393.99387,195.474785 1393.99387,435.679312 L1393.99387,919.767436 C1393.99387,1159.97196 1198.51909,1355.44675 958.314561,1355.44675 C718.110034,1355.44675 522.63525,1159.97196 522.63525,919.767436 L522.63525,435.679312 C522.63525,195.474785 718.110034,0 958.314561,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMicSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMicSolid, _Component);

  var _super = _createSuper(IconMicSolid);

  function IconMicSolid() {
    _classCallCheck(this, IconMicSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMicSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMic",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMicSolid.displayName = "IconMicSolid";
  return IconMicSolid;
}(Component);

IconMicSolid.glyphName = 'mic';
IconMicSolid.variant = 'Solid';
IconMicSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMicSolid;
export { IconMicSolid };